<template>
  <div class="row team-row justify-content-start align-content-center" v-if="participantData.userTeam != null">
    <div
      v-for="(slotData, index) in participantData.userTeam.playersPoints.filter(s => s.slot !== 'sub')"
      :key="slotData.slot"
      class="col-xl-3 col-lg-4 col-md-5 col-sm-6 col-8 align-content-center"
    >
      <PlayerPoints
        :is-triple="participantData.userTeam.chipUsed == 1"
        :is-captain="participantData.userTeam.captain == index + 1"
        @showDetails="showDetailsModal"
        :playerPoints="slotData"
        :matchesThisFixture="playerMatchesFixture(slotData.player)"
        :role="slotData.slot"
        :teamPlayer="slotData.player"
        :img_url="role_images[slotData.slot]"
        :roles_img_url="role_images"
      />
    </div>
    <div class="col-xl-3 col-lg-4 col-md-5 col-sm-6 col-8 align-content-center">
      <TeamPoints
        :role="'team'"
        @showDetails="showDetailsModal"
        :teamTeam="participantData.userTeam.teamPoints.team"
        :matchesThisFixture="playerMatchesFixture(participantData.userTeam.teamPoints.team)"
        :teamPoints="participantData.userTeam.teamPoints"
        :img_url="role_images['team']"
        :roles_img_url="role_images"
      />
    </div>
    <div
      v-if="participantData.userTeam.playersPoints.find(s => s.slot === 'sub')"
      class="col-xl-3 col-lg-4 col-md-5 col-sm-6 col-8 align-content-center"
    >
      <PlayerPoints
        @showDetails="showDetailsModal"
        :playerPoints="participantData.userTeam.playersPoints.find(s => s.slot === 'sub')"
        :matchesThisFixture="playerMatchesFixture(participantData.userTeam.playersPoints.find(s => s.slot === 'sub')?.player)"
        :isbenchboost="participantData.userTeam.chipUsed == 4"
        :role="'sub'"
        :teamPlayer="participantData.userTeam.playersPoints.find(s => s.slot === 'sub')?.player"
        :img_url="role_images['sub']"
        :roles_img_url="role_images"
      />
    </div>
  </div>
  <div class="row justify-content-center"></div>
  <div>
    <MyModal
      :bgColor="'var(--BACKGROUND-LIGHTER)'"
      :openModal="this.openModal"
      @closeModal="closeDetailsModal"
      :title="`${participant.userLogin}'s ${fixture.title} points details`"
    >
      <div
        v-if="
          participantData != null &&
          participantData.userTeam != null &&
          detailsData.team == null
        "
        class="team-points"
        ref="pointsContainer"
      >
        <PlayerPointsGamesCardV2
          class="team-points-details align-content-center"
          :gamesList="fixtureGames"
          :isCaptain="isDetailsCaptain"
          :isTriple="isDetailsTriple"
          :gamesPointsDetails="detailsData.gamesPointsDetails"
          :totalPointsA="detailsData.totalPoints"
        />
      </div>
      <div
        v-if="
          participantData != null &&
          participantData.userTeam != null &&
          detailsData.team != null
        "
        class="team-points"
        ref="pointsContainer"
      >
        <TeamPointsGamesCardV2
          class="team-points-details align-content-center"
          :gamesList="fixtureGames"
          :isCaptain="false"
          :gamesPointsDetails="detailsData.gamesPointsDetails"
          :totalPointsA="detailsData.totalPoints"
        />
      </div>
    </MyModal>
  </div>
</template>

<script>
import MyModal from "@/components/MyModal.vue";
import PlayerPointsGamesCardV2 from "@/components/Points/PlayerPointsGamesCardV2.vue";
import TeamPointsGamesCardV2 from "@/components/Points/TeamPointsGamesCardV2.vue";
import PlayerPoints from "@/components/Points/PlayerPoints.vue";
import TeamPoints from "@/components/Points/TeamPoints.vue";
export default {
  name: "ParticipantDetails",
  components: {
    MyModal,
    PlayerPointsGamesCardV2,
    TeamPointsGamesCardV2,
    PlayerPoints,
    TeamPoints,
  },
  props: {
    participant: Object,
    fixtureGames: Array,
    fixture: Object,
  },
  data() {
    return {
      role_images: {
        top: "https://cdn3.emoji.gg/emojis/7990-lol-role-top.png",
        jungle: "https://cdn3.emoji.gg/emojis/1152-lol-role-jungle.png",
        mid: "https://cdn3.emoji.gg/emojis/6934-lol-role-mid.png",
        bottom: "https://cdn3.emoji.gg/emojis/9366-lol-role-bot.png",
        support: "https://cdn3.emoji.gg/emojis/7990-lol-role-support.png",
        sub: "https://cdn3.emoji.gg/emojis/2724-lol-role-fill.png",
        team: "https://i.imgur.com/bLArMp2.png",
      },
      participantData: null,
      openModal: false,
      detailsData: null,
      newLeagueName: "",
      invitationCode: "",
      showDetails: false,
      isDetailsCaptain: false,
      isDetailsTriple: false,
      showTeamDetailsModal: false,
    };
  },
  computed: {
    matchStatus() {
      if (
        !this.participantData?.userTeam ||
        !this.fixtureGames ||
        !this.fixture
      ) {
        return { planned: 0, playing: 0, finished: 0 };
      }

      const fixtureId = this.fixture.id;
      const userTeam = this.participantData.userTeam;

      // Collect all gamesPointsDetails across all slots (excluding sub)
      const slots = [
        ...(userTeam.playersPoints ?? []).map((s) => ({
          points: s,
          code: s.player?.team?.code,
        })),
        { points: userTeam.teamPoints, code: userTeam.teamPoints?.team?.code },
      ];

      let planned = 0,
        playing = 0,
        finished = 0;

      for (const slot of slots) {
        if (!slot.code || !slot.points) continue;

        // Find this slot's scheduled matches in this fixture
        const scheduledMatchIds = [
          ...new Set(
            this.fixtureGames
              .filter(
                (g) =>
                  g.fixtureId === fixtureId &&
                  (g.gameTeam1 === slot.code || g.gameTeam2 === slot.code),
              )
              .map((g) => g.matchId),
          ),
        ];

        // Find match states from gamesPointsDetails
        const playedGames = slot.points.gamesPointsDetails ?? [];

        for (const matchId of scheduledMatchIds) {
          const foundGame = playedGames.find((g) => g.matchId === matchId);

          if (!foundGame) {
            planned++;
          } else if (foundGame.match?.state === "FINISHED") {
            finished++;
          } else if (foundGame.match?.state === "STARTED") {
            playing++;
          } else {
            planned++;
          }
        }
      }

      return { planned, playing, finished };
    },
  },
  emits: ["match-status-update"],
  mounted() {
    this.participantData = JSON.parse(JSON.stringify(this.participant));
    this.correctEmptyPlayers();
  },
  watch: {
    // Watch for changes in the 'playerDetails' prop
    participant: {
      handler(newparticipant, oldparticipant) {
        this.participantData = JSON.parse(JSON.stringify(this.participant));
        this.correctEmptyPlayers();
      },
      immediate: true,
    },
    matchStatus: {
      handler(val) {
        this.$emit("match-status-update", {
          userId: this.participantData.userId,
          ...val,
        });
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    playerMatchesFixture(entity) {
      if (!entity) return [];
      return this.fixtureGames.filter((game) => {
        if (entity.code) {
          return (
            game.fixtureId == this.fixture.id &&
            (game.gameTeam1 == entity.code || game.gameTeam2 == entity.code)
          );
        } else if (entity.team?.code) {
          return (
            game.fixtureId == this.fixture.id &&
            (game.gameTeam1 == entity.team.code ||
              game.gameTeam2 == entity.team.code)
          );
        }
      });
    },
    showDetailsModal({ playerDetails, isCaptain, isTriple }) {
      this.openModal = true;
      this.detailsData = playerDetails;
      this.isDetailsCaptain = isCaptain;
      this.isDetailsTriple = isTriple;
    },
    closeDetailsModal(name) {
      this.openModal = false;
    },
    scrollRight() {
      const cardWidth = this.$refs.pointsContainer.children[0].offsetWidth; // get width of the first card
      const scrollAmount = cardWidth; // scroll width for 4 cards
      this.$refs.pointsContainer.scrollLeft += scrollAmount; // scroll right
    },
    scrollLeft() {
      const cardWidth = this.$refs.pointsContainer.children[0].offsetWidth; // get width of the first card
      const scrollAmount = cardWidth; // scroll width for 4 cards
      this.$refs.pointsContainer.scrollLeft -= scrollAmount; // scroll left
    },
    toggleDetailsVisibility() {
      this.showDetails = !this.showDetails;
    },
    correctEmptyPlayers() {
      if (this.participantData.userTeam == null) return;
      for (const slot of this.participantData.userTeam.playersPoints ?? []) {
        if (!slot.gamesPointsDetails?.length) {
          slot.gamesPointsDetails = [slot.player];
        }
      }
      if (!this.participantData.userTeam.teamPoints?.gamesPointsDetails?.length) {
        this.participantData.userTeam.teamPoints.gamesPointsDetails = [
          this.participantData.userTeam.teamPoints.team,
        ];
      }
    },
  },
};
</script>
<style scoped>
.team-row {
  flex-wrap: nowrap;
  height: 10vh !important;
  /* overflow-x: scroll; */
}
.fill-height {
  height: 100%;
  display: flex;
  align-items: center;
}
.team-points {
  display: flex;
  justify-content: center;
}

.team-points-details {
  flex: 0 0 auto; /* Optional: Add some space between cards */
  height: 50%;
}

::-webkit-scrollbar {
  width: 10px;
  height: 20px;
}
#panel {
  height: 100%;
}

.w-80 {
  width: 80%;
}

.login-input,
.account-btn {
  border-radius: 15px;
  border: none;
}

.login-input {
  box-shadow: 0 0.5rem 0.5rem rgba(0, 0, 0, 0.15) !important;
  padding: 15px 10px;
}

.register-input {
  border-radius: 25px;
  border-color: grey;
}

.account-btn {
  color: white;
  font-size: 2vw;
  font-weight: bold;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
  padding: 5px;
}

.pink-btn {
  background: pink;
}

.grey-btn {
  background: gray;
}

input.has-error {
  border: 1px solid pink;
}

p.has-error {
  color: pink;
}
.register-btn {
  color: white;
  font-size: 120%;
  font-weight: bold;
  border-radius: 15px;
  border: none;
  width: 100%;
}

.btn-purple {
  background-color: var(--PRIMARY-LIGHTER);
  font-weight: 800;
  color: white;
  border: none;
}
</style>
